<template>
  <li class="hierarchy__list-item list-group-item p-0">
    <div class="hierarchy__link d-flex flex-wrap align-items-center">
      <div class="hierarchy__logo">
        <Skeletor width="50" height="20" />
      </div>

      <div class="hierarchy__name ms-2">
        <Skeletor width="25%" />
      </div>

      <div class="d-flex ms-auto">
        <div class="hierarchy__gbin">GBIN: <Skeletor width="110" /></div>

        <div class="hierarchy__icon ms-2">
          <i class="fal fa-chevron-right mt-2"></i>
        </div>
      </div>
    </div>

    <ul class="hierarchy__list list-group list-group-flush">
      <li
        v-for="index in 5"
        :key="index"
        class="hierarchy__list-item list-group-item p-0"
      >
        <div class="hierarchy__link d-flex flex-wrap align-items-center">
          <div class="hierarchy__logo">
            <Skeletor width="50" height="20" />
          </div>

          <div class="hierarchy__name ms-2">
            <Skeletor width="50%" />
          </div>

          <div class="d-flex ms-auto">
            <div class="hierarchy__gbin">GBIN: <Skeletor width="110" /></div>

            <div class="hierarchy__icon ms-2">
              <i class="fal fa-chevron-right mt-2"></i>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </li>
</template>
